import {
  ImportedNgModuleProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { LocalStorageDataAccess, SOFTLINE_STORE_FEATURES, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { AuftragStore } from './store/auftrag.store';
import {
  ApplicationStore,
  SOFTLINE_CONFIG_SETTINGS,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { AuftragService } from './services/auftragService';
import { BelegvermerkStore } from './store/belegvermerk.store';
import { TimeReportStore } from './store/timeReport.store';
import { BeweauStore } from './store/beweau.store';
import { PictureResourceService } from './services/picture-resource.service';
import { DepartmentSettingsComponent } from './settings/department-settings.component';
import { TimeReportService } from './services/time-report.service';

export const goldschmiedeProviders: (Provider | ImportedNgModuleProviders)[] = [
  provideEnvironmentInitializer(async () => {
    const store = inject(Store);

    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'goldschmiede',
      language: 'de',
      translations: de,
    });

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Goldschmiede',
      route: '/goldschmiede',
      icon: 'fa-regular fa-hammer',
      //permission: SOFTLINE_PERMISSION_GOLDSCHMIEDE
    });
  }),
  { provide: SOFTLINE_STORE_FEATURES, useExisting: AuftragStore, multi: true },
  { provide: SOFTLINE_STORE_FEATURES, useExisting: BeweauStore, multi: true },
  { provide: SOFTLINE_STORE_FEATURES, useExisting: BelegvermerkStore, multi: true },
  { provide: SOFTLINE_STORE_FEATURES, useExisting: TimeReportStore, multi: true },
  {
    provide: SOFTLINE_CONFIG_SETTINGS,
    multi: true,
    useValue: {
      key: 'SOFTLINE_SETTING_FEICHTINGER_ABTEILUNG',
      component: DepartmentSettingsComponent,
      title: 'Abteilung',
      default: {},
      icon: 'fa-regular fa-font-case',
    },
  },
  AuftragService,
  TimeReportService,
  PictureResourceService,
];
